import { api2 , apiUpload } from './ApiService';

export default class GamePackageService {
    static async getDiamonds(){
        let response =  await api2.get(`/api/v1/game/package/diamond`)
        return response.data
    }

    static async search(key, game_id, page, perpage){
        let data ={
            searchKey: key,
            gameId: game_id,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/game/package/search`,data)
        return response.data
    }
 
    static async create(data){
        let response = await apiUpload.post(`/api/v1/game/package/create`,data)
        return response.data
    }
    static async update(data){
        let response = await apiUpload.post(`/api/v1/game/package/update`,data)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/game/package/delete`,data)
        return response.data
    }
    static async createDiamond(data){
        let response = await apiUpload.post(`/api/v1/game/package/diamond/create`,data)
        return response.data
    }
     static async updateDiamond(data){
        let response = await apiUpload.post(`/api/v1/game/package/diamond/update`,data)
        return response.data
    }
    static async deleteDiamond(data){
        let response = await api2.post(`/api/v1/game/package/diamond/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/GamePackageService.js